import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TagGroup"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.5 12C8.32843 12 9 11.3284 9 10.5C9 9.67157 8.32843 9 7.5 9C6.67157 9 6 9.67157 6 10.5C6 11.3284 6.67157 12 7.5 12ZM11.4675 22.2825C11.609 22.4229 11.8006 22.5012 12 22.5C12.1994 22.5012 12.391 22.4229 12.5325 22.2825L19.2825 15.5325C19.4245 15.3917 19.5043 15.2 19.5043 15C19.5043 14.8 19.4245 14.6083 19.2825 14.4675L11.25 6.4425C10.97 6.16081 10.5897 6.00167 10.1925 6H4.5C3.67157 6 3 6.67157 3 7.5V13.1925C3.00167 13.5897 3.16081 13.97 3.4425 14.25L11.4675 22.2825ZM4.5 13.1925V7.5H10.1925L17.6925 15L12 20.6925L4.5 13.1925ZM20.7825 9.9675L12.75 1.9425C12.47 1.66081 12.0897 1.50167 11.6925 1.5H6C5.17157 1.5 4.5 2.17157 4.5 3V4.5H6V3H11.6925L19.1925 10.5L18.2175 11.4675L19.2825 12.5325L20.7825 11.0325C20.9245 10.8917 21.0043 10.7 21.0043 10.5C21.0043 10.3 20.9245 10.1083 20.7825 9.9675Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TagGroup.vue"]]);
